import { render, staticRenderFns } from "./attendee.avatar.vue?vue&type=template&id=801f0930&scoped=true&"
import script from "./attendee.avatar.vue?vue&type=script&lang=js&"
export * from "./attendee.avatar.vue?vue&type=script&lang=js&"
import style0 from "./attendee.avatar.vue?vue&type=style&index=0&id=801f0930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801f0930",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
